import React from 'react'

import { InteriorPageLayout } from '@/layout/InteriorPageLayout'
import { LiquidityNutrimaticAddLayout } from '@/widgets/liquidity/nutrimatic/LiquidityNutrimaticAddLayout'
import { LiquidityAddWidget } from '../../widgets/liquidity/add'
import { mainAppResolveWidgetRoute } from '../../widgets/navigation'

export default function AddLiquidity() {
  return (
    <InteriorPageLayout className="nm-swap-tablet-page max-lg:flex max-lg:min-h-0 max-lg:flex-1 max-lg:flex-col max-lg:space-y-0 max-lg:overflow-hidden lg:space-y-0">
      <LiquidityAddWidget embedded resolveRoute={mainAppResolveWidgetRoute}>
        {(controller) => (
          <div className="max-lg:flex max-lg:min-h-0 max-lg:flex-1 max-lg:flex-col max-lg:overflow-hidden lg:flex lg:min-h-0 lg:flex-1 lg:flex-col">
            <LiquidityNutrimaticAddLayout controller={controller} />
          </div>
        )}
      </LiquidityAddWidget>
    </InteriorPageLayout>
  )
}
